<template>
  <v-img
    :src="imagen"
    height="180"
    width="180"
    contain
    class="blue-grey darken-4">
  </v-img>
</template>

<script>
export default {
  name: 'ShowThumbnail',
  props: {
    publicKey: {
      default() {
        return this.publicKey || null;
      },
    },
  },
  data() {
    return {
      imagen: '',
    };
  },
  mounted() {
    this.descargarImagen();
  },
  methods: {
    descargarImagen() {
      this.axios.get(`${this.$urlFileServer}/${this.publicKey}/thumbnail`)
        .then((res) => {
          // console.log(res.data);
          this.imagen = `${this.$urlFileServer}/${res.data}`;
        });
      // .catch((err) => console.log(err));
    },
  },
  computed: {},
  watch: {
    publicKey: {
      handler() {
        this.descargarImagen();
      },
    },
  },
};
</script>

<style lang="scss">
</style>
